import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";
import { Label as TypoLabel } from "utils/styling/typography.styled";

export const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    // height: 75vh;
    background-color: ${colourScheme.primaryDark};
    border: 1px solid ${colourScheme.primary};
    border-radius: 0.5rem;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1.25rem;
    padding: 1rem;
`;

export const RowContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;
export const Label = styled(TypoLabel)`
    display: inline-flex;
    align-items: center;
`;
export const Icon = styled.div`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 1.5rem;
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    margin-left: 0.5rem;
    svg,
    img {
        opacity: 0.5;
        height: 100%;
        width: 100%;
    }
    & > span {
        padding: 0.25rem;
        color: ${colourScheme.secondary};
    }
`;
